import { onActivated, onDeactivated, ref } from 'vue';

/**
 * Tracks whether a <KeepAlive>-cached component is currently active.
 *
 * A deactivated KeepAlive component keeps its render effects alive, so a nested <RouterView /> inside it
 * keeps rendering the current route's matched component at its depth. For CRM screens that means a cached
 * screen mounts its own FlyoutHost whenever another screen opens a detail flyout, and because the drawer
 * teleports to <body>, two flyouts stack on top of each other. Gate nested RouterViews with this flag.
 */
export const useKeepAliveActive = () => {
  const isKeepAliveActive = ref(true);

  onActivated(() => isKeepAliveActive.value = true);
  onDeactivated(() => isKeepAliveActive.value = false);

  return { isKeepAliveActive };
};
